'use strict';

var slicedToArray = require('../../../../node_modules/@babel/runtime/helpers/slicedToArray.js');
var objectWithoutProperties = require('../../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
var withStyles = require('../../../Styles/withStyles.js');
var Button = require('../../../Inputs/Buttons/Button/Button.js');
var Tooltip = require('../../../DataDisplay/Tooltips/Tooltip.js');
var IconButton = require('../../../Inputs/Buttons/IconButton.js');
var Apps = require('../../../../IconsAndImages/Icons/Apps.js');
var AppTile = require('../../../../HousecallComponents/Apps/AppTile/AppTile.js');
var Popover = require('../../../../node_modules/@material-ui/core/esm/Popover/Popover.js');
var GridList = require('../../../../node_modules/@material-ui/core/esm/GridList/GridList.js');
var GridListTile = require('../../../../node_modules/@material-ui/core/esm/GridListTile/GridListTile.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var styles = function styles(theme) {
  return {
    popoverContainer: {
      width: 270,
      padding: '8px'
    },
    buttonStyle: {
      textAlign: 'center',
      padding: '6px 0'
    }
  };
};

var MyAppsIcon = function MyAppsIcon(_ref) {
  var classes = _ref.classes,
      myApps = _ref.myApps;
      objectWithoutProperties(_ref, ["classes", "myApps"]);

  var _useState = React.useState(false),
      _useState2 = slicedToArray(_useState, 2),
      myAppsMenuOpen = _useState2[0],
      setMyAppsMenuOpen = _useState2[1];

  var _useState3 = React.useState(null),
      _useState4 = slicedToArray(_useState3, 2),
      myAppsMenuAnchor = _useState4[0],
      setMyAppsMenuAnchor = _useState4[1];

  var handleMyAppsMenuOpen = function handleMyAppsMenuOpen(event, open) {
    setMyAppsMenuAnchor(event.currentTarget);
    setMyAppsMenuOpen(open);
  };

  return React__default["default"].createElement(React.Fragment, null, React__default["default"].createElement(Tooltip, {
    title: "Apps"
  }, React__default["default"].createElement(IconButton, {
    onClick: function onClick(event) {
      return handleMyAppsMenuOpen(event, true);
    }
  }, React__default["default"].createElement(Apps, null))), React__default["default"].createElement(Popover["default"], {
    open: myAppsMenuOpen,
    anchorEl: myAppsMenuAnchor,
    anchorReference: "anchorEl",
    onClose: function onClose(event) {
      handleMyAppsMenuOpen(event, false);
    },
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'center'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'center'
    }
  }, React__default["default"].createElement(GridList["default"], {
    cols: 3,
    cellHeight: 90,
    spacing: 0,
    className: classes.popoverContainer
  }, myApps.map(function (myApp, index) {
    return React__default["default"].createElement(GridListTile["default"], null, React__default["default"].createElement(AppTile, {
      icon: myApp.icon,
      appName: myApp.appName,
      openAppURL: myApp.openAppURL
    }));
  })), React__default["default"].createElement("div", {
    className: classes.buttonStyle
  }, React__default["default"].createElement(Button["default"], {
    color: "primary"
  }, "Go to Appstore"))));
};

var MyAppsIcon$1 = withStyles["default"](styles)(MyAppsIcon);

module.exports = MyAppsIcon$1;
